import { useId } from "react";

/**
 * The grey silhouette WhatsApp draws for a chat without a profile photo.
 *
 * The Cloud API never sends us the client's photo, so this is what every chat
 * would wear in WhatsApp too — and what makes the list read as theirs.
 */
export function Avatar({ size = 49 }: { size?: number }) {
  // One clip per instance: an `id` shared by every avatar on the screen would
  // resolve to whichever came first in the document.
  const clip = useId();
  return (
    <svg
      viewBox="0 0 212 212"
      width={size}
      height={size}
      aria-hidden="true"
      className="shrink-0"
    >
      <clipPath id={clip}>
        <circle cx="106" cy="106" r="106" />
      </clipPath>
      <g clipPath={`url(#${clip})`}>
        <rect width="212" height="212" fill="#dfe5e7" />
        <circle cx="106" cy="86" r="40" fill="#fff" />
        <ellipse cx="106" cy="212" rx="78" ry="70" fill="#fff" />
      </g>
    </svg>
  );
}
